<template>
  <div id="language">
        <v-container grid-list-xl fluid>
      <v-layout row wrap>
    <v-toolbar color="transparent" card class="mb-2">
      <h4>Ngôn ngữ</h4>
      <v-spacer></v-spacer>
      <v-select
        :items="platformOptions"
        v-model="selectedPlatformOption"
        label="Platform"
        item-text="text"
        item-value="value"
        @change="onFilter"
      ></v-select>
    </v-toolbar>
    <v-card style="width: 100%;">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm"
          v-model="searchText"
          v-on:keyup.enter="onFilter()"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="onOpenDialogCreateUpdateLanguage(null)">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Thêm ngôn ngữ</span>
        </v-tooltip>
         <v-tooltip bottom>
          <v-btn icon slot="activator" @click="onOpenDialogCreateLanguageJSON()">
            <v-icon>data_object</v-icon>
          </v-btn>
          <span>Thêm ngôn ngữ (JSON)</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="$router.push('/changelog')">
            <v-icon>rocket_launch</v-icon>
          </v-btn>
          <span>Cập nhật phiên bản</span>
        </v-tooltip>
        <v-menu offset-y>
            <v-btn icon flat slot="activator">
              <v-icon>expand_more</v-icon>
            </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, index) in menu"
              :key="index"
              @click="item.click()"
            >
              <v-list-tile-title>
                <v-icon class="menu-item-icon">{{
                  item.icon
                }}</v-icon>
                <span>{{ item.title }}</span>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-data-table
        item-key="key"
        :headers="headers"
        :items="filteredLanguages"
        :loading="isLoading"
        :rows-per-page-items="[10, 20,50,100]"
      >
        <template v-slot:items="props">
          <tr :class="{'red lighten-4': !props.item['vi-VN'] || !props.item['en-US']}">
            <td style="width: 50px;">   <v-icon :color="checkIsMobile(props.item.key) ? 'orange' : 'teal'">{{ checkIsMobile(props.item.key) ? 'smartphone' : 'web' }}</v-icon></td>
            <td>{{ props.item.key }}</td>
            <td>
              <div class="clamp-text">
                {{ props.item['vi-VN'] }}
            </div>
            </td>
            <td>
              <div class="clamp-text">
                {{ props.item['en-US'] }}
            </div>
          </td>
            <td>
              <v-tooltip bottom>
                <v-btn icon slot="activator" @click="onOpenDialogCreateUpdateLanguage(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Sửa</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        </v-data-table>

      <!-- Dialog thêm ngôn ngữ -->
      <dialog-create-update-language ref="dialogCreateUpdateLanguage" @success="getLanguagesData" />

      <!-- Dialog thêm ngôn ngữ (JSON) -->
      <dialog-create-language-json ref="dialogCreateLanguageJSON" @success="getLanguagesData" />
    </v-card>
          </v-layout>
    </v-container>
  </div>
</template>

<script>
import DialogCreateUpdateLanguage from './DialogCreateUpdateLanguage';
import { mapActions } from 'vuex';
import DialogCreateLanguageJson from './DialogCreateLanguageJson';

export default {
  components: { DialogCreateUpdateLanguage, DialogCreateLanguageJson },
  data () {
    return {
      searchText: '',
      isLoading: false,
      headers: [
        {
          text: '',
          value: 'platform',
          sortable: false
        },
        {
          text: 'Khoá',
          value: 'key'
        },
        {
          text: 'Tiếng Việt',
          value: 'vi-VN'
        },
        {
          text: 'Tiếng Anh',
          value: 'en-US'
        }
      ],
      originalLanguages: [],
      languages: [],
      filteredLanguages: [],

      platformOptions: [
        {
          text: 'Tất cả',
          value: 'all'
        },
        {
          text: 'Web',
          value: 'web'
        },
        {
          text: 'Mobile',
          value: 'mobile'
        }
      ],
      selectedPlatformOption: 'all',
      menu: [
        {
          title: 'Ghi đè dev (Tất cả)',
          icon: 'desktop_windows',
          click: () => { this.overrideLanguageDev() },
        },
        {
          title: 'Log JSON',
          icon: 'terminal',
          click: () => { console.log(this.originalLanguages) },
        },
      ],
    };
  },
  computed: {},
  watch: {
    selectedPlatformOption (newValue) {
      const platform = this.platformOptions.find(option => option.value === newValue);
      this.menu[0].title = `Ghi đè dev (${platform.text})`;
    },
  },
  mounted () {
    this.getLanguagesData();
  },
  methods: {
    ...mapActions([
      'getLanguages',
      'updateLanguageDev'
    ]),

    onFilter () {
      switch (this.selectedPlatformOption) {
        case 'all':
          this.filteredLanguages = this.languages;
          break;
        case 'web':
          this.filteredLanguages = this.languages.filter(language => !language.key.startsWith('M2.'));
          break;
        case 'mobile':
          this.filteredLanguages = this.languages.filter(language => language.key.startsWith('M2.'));
          break;
      }

      const searchString = this.searchText.trim().toLowerCase();

      this.filteredLanguages = this.filteredLanguages.filter(language =>
        language.key.toLowerCase().includes(searchString) ||
        language['vi-VN'].toLowerCase().includes(searchString) ||
        language['en-US'].toLowerCase().includes(searchString)
      );
    },

    getLanguagesData () {
      this.isLoading = true;
      this.getLanguages({ isAll: true }).then(res => {
        this.originalLanguages = res;
        this.languages = this.transformLanguage(res);
        this.onFilter();
        this.isLoading = false;
      }).catch(_ => {
        this.isLoading = false;
      });
    },

    transformLanguage (language) {
      const allKeys = new Set();
      Object.keys(language['vi-VN']).forEach((key) => allKeys.add(key));
      Object.keys(language['en-US']).forEach((key) => allKeys.add(key));

      return Array.from(allKeys).map((key) => ({
        key,
        'vi-VN': language['vi-VN'][key] || '',
        'en-US': language['en-US'][key] || '',
      }));
    },

    onOpenDialogCreateUpdateLanguage (selectedLanguage) {
      this.$refs.dialogCreateUpdateLanguage.open(selectedLanguage);
    },

    onOpenDialogCreateLanguageJSON () {
      this.$refs.dialogCreateLanguageJSON.open();
    },

    onCloseDialogCreateUpdateLanguage () {
      this.$refs.dialogCreateUpdateLanguage.close();
    },

    checkIsMobile (key) {
      return key.startsWith('M2.');
    },

    overrideLanguageDev () {
      const request  = this.filteredLanguages.reduce((acc, item) => {
        acc[item.key] = {
          'vi-VN': item['vi-VN'],
          'en-US': item['en-US'],
        };
        return acc;
      }, {});

      this.updateLanguageDev(request).then(() => {
        window.getApp.showMessage('Ghi đè dev thành công', 'success');
      }).catch(_ => {
        window.getApp.showMessage('Lỗi khi ghi đè dev', 'error');
      });
    }
  }
};
</script>
<style>.clamp-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}</style>



// WEBPACK FOOTER //
// src/pages/language/Language.vue